import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import getKhattabatStore from "../../stores/khattabat-stores";
import getKhattabatMatchingStore from "../../stores/khattabat-stores/matching-stores";
import { getMatchingSearchCriteria } from "../../helpers/et3-matching-search-criteria";

export const apiCallGetMatchesIds = async (): Promise<{
  data: number[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { currentClientInformation } = getKhattabatMatchingStore();

  const khattabaUUID = getKhattabatStore().alkhattabaUUID.get();
  const { userId, userUUID } = currentClientInformation.get();

  const { status, data, et3Error } = await post<number[]>(
    `khattabat/get101MMatchesIds`,
    {
      khattabaUUID,
      userID: userId,
      userUUID,
      ...getMatchingSearchCriteria()
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
